const parse = () => {
  // iFrame url
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const clubId = params.get('ga-clubId');
  const clubHash = params.get('ga-clubHash');
  const parentUrlStr = params.get('ga-parentUrl') || '';

  // Parent url where iframe is embedded
  let parentUrl = null;
  let backFromStripe = false;
  let orderId = '';
  let status = '';

  if (parentUrlStr) {
    parentUrl = new URL(parentUrlStr);
    const paramsParent = new URLSearchParams(parentUrl.search);
    orderId = paramsParent.get('ga-orderId');
    status = paramsParent.get('ga-status');
    backFromStripe = !!orderId && !!status;

    // Remove all ga- params from parent url
    const paramArray = Array.from(paramsParent);
    const filteredArray = paramArray.filter(([key]) => !key.startsWith('ga-'));
    const filteredParams = new URLSearchParams(filteredArray);
    parentUrl.search = filteredParams.toString();
  }

  return { clubId, clubHash, orderId, status, backFromStripe, parentUrl };
};

export default parse;
